import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { colorsMapping, VariantColor } from '@repo/toolkit/colors'
import { SVGFC } from '@repo/toolkit/types'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import React from 'react'

type Props = {
  label: string
  value: string
  icon: SVGFC
  variant: VariantColor
}

const UserRoleCard = ({ label, value, icon, variant }: Props) => {
  return (
    <InnerBox className="rounded-lg p-2 flex flex-row items-center gap-2">
      <Badge
        variant={variant}
        size="flexible"
        className="rounded p-2"
        icon={React.createElement(icon, {
          color: colorsMapping[variant].text,
          width: '26',
          height: '26'
        })}
      />
      <div className="flex flex-col gap-1">
        <Typography variant="tag" color={tailwindColors.grey.lighter}>
          {label}
        </Typography>
        <Typography variant="tag" color={colorsMapping[variant].text}>
          {value}
        </Typography>
      </div>
    </InnerBox>
  )
}

export default UserRoleCard
